import React, { useState, useEffect } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Checkbox,
	FormControlLabel
} from "@mui/material";
import { NavLink } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import Util from "../../validation/index";
import { adminGetCurrencyMaster } from "../../redux/actions/adminGetCurrencyMasterAction";
import { adminAddOrUpdateCurrency } from "../../redux/actions/adminAddOrUpdateCurrencyAction";
import { adminCurrencyCode } from "../../redux/actions/adminCurrencyCodeAction";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import SearchIcon from "@mui/icons-material/Search";
// import val from "../../getThemeDetails";
import val from "../../getThemeDetails"

const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

function AdminCurrencyMaster() {
	const [searchCurrency, setSearchCurrency] = useState("");

	const [page, setPage] = useState(0);
	const [editOpen, setEditOpen] = React.useState(false);
	const [viewOpen, setViewOpen] = React.useState(false);
	const [addOpen, setAddOpen] = React.useState(false);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [isLoading, setIsLoading] = useState(false);

	const [getCurrencyMasterStatus, setGetCurrencyMasterStatus] = useState(false);
	const [getCurrencyMasterArray, setGetCurrencyMasterArray] = useState("");

	const [addOrUpdateCurrencyStatus, setAddOrUpdateCurrencyStatus] =
		useState(false);
	const [addOrUpdateCurrencyArray, setAddOrUpdateCurrencyArray] = useState("");

	const [notificationOpen, setNotificationOpen] = React.useState(false);

	const view = "view";
	const edit = "edit";

	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;
	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	var authToken = regenerateTokenRes.data.AuthToken;
	const classes = useStyles();
	const dispatch = useDispatch();

	const [user, setUser] = useState({
		currencyId: "",
		currency: "",
		currencyCode: "",
		walletName: ""
	});

	const { currencyId, currency, currencyCode, walletName } = user;

	const onInputChange = ({ target: { name, value } }, type) => {
		// setUser({ ...user, [e.target.name]: e.target.value });
		const obj = {
			...user
		};

		if (type == "number") {
			obj[name] = Util.verifyMobile(value) ? value : obj[name];
		} else if (type == "alphabet") {
			obj[name] = Util.verifyAlphabet(value) ? value : obj[name];
		} else if (type == "both") {
			obj[name] = Util.alphaNumeric(value) ? value : obj[name];
		} else if (type == "currencyCode") {
			const m = /^[a-zA-Z]{0,3}$/;
			obj[name] = m.test(value) ? value : obj[name];
		} else {
			// obj[name] = value.trim()
			obj[name] = Util.noWhiteSpace(value) ? value : obj[name];
		}
		setUser(obj);
	};

	const adminCurrencyList = useSelector(
		({ adminCurrencyList }) => adminCurrencyList
	);

	const adminCurrencyCodeRes = useSelector(
		({ adminCurrencyCode }) => adminCurrencyCode
	);

	const getCurrencyMasterRes = useSelector(
		({ adminGetCurrencyMaster }) => adminGetCurrencyMaster
	);

	const addOrUpdateCurrencyRes = useSelector(
		({ adminAddOrUpdateCurrency }) => adminAddOrUpdateCurrency
	);

	const handleNoticationClose = () => {
		setNotificationOpen(false);
	};

	const handleChange = ({ target: { name, value } }) => {
		if (name === "searchCurrency") {
			setSearchCurrency(value == "Select Currency Code" ? "" : value);
		}
	};

	const currencyCodeReq = () => {
		let req = {
			loginDetails: {
				// adminId: "2"
				adminId: val.adminIDS

			}
		};
		dispatch(adminCurrencyCode(req, authToken));
	};

	// useEffect(() => {
	// 	currencyCodeReq();
	// }, []);

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			currencyCodeReq();
			getCurrencyMasterListReq();
		}
	}, [regenerateTokenRes.data.AuthToken]);

	const getCurrencyMasterListReq = () => {
		setIsLoading(true);
		setGetCurrencyMasterStatus(true);
		let req = {
			ownerMasterRequestVO: {
				// adminId: 2,
				adminId: val.adminIDS,
				currency: searchCurrency
			}
		};
		dispatch(adminGetCurrencyMaster(req, authToken));
	};

	const getCurrencyMasterFunc = () => {
		if (getCurrencyMasterStatus) {
			setIsLoading(false);
			if (getCurrencyMasterRes.data.status == "success") {
				setGetCurrencyMasterArray(
					[].concat(getCurrencyMasterRes.data.currencyDetailsResponseVoList)
				);
			}
			if (getCurrencyMasterRes.data.status == "failed") {
				setGetCurrencyMasterArray(getCurrencyMasterRes.data);
				NotificationPopups(
					"error",
					"Failed",
					getCurrencyMasterRes.data.description
				);
				if (
					getCurrencyMasterRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getCurrencyMasterRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getCurrencyMasterRes.data.status == "Failed") {
				setGetCurrencyMasterArray(getCurrencyMasterRes.data);
				NotificationPopups(
					"error",
					"Failed",
					getCurrencyMasterRes.data.description
				);
				if (
					getCurrencyMasterRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getCurrencyMasterRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getCurrencyMasterRes.data.status == "NOT FOUND") {
				setGetCurrencyMasterArray(getCurrencyMasterRes.data);
				NotificationPopups(
					"error",
					"Failed",
					getCurrencyMasterRes.data.description
				);
			}
		}
	};

	useEffect(() => {
		getCurrencyMasterFunc();
	}, [getCurrencyMasterRes.data.status]);

	const addOrUpdateCurrencyReq = () => {
		setAddOrUpdateCurrencyStatus(true);
		setAddOpen(false);
		setEditOpen(false);
		let req = {
			currencyName: currency,
			currencyId: currencyId,
			code: currencyCode,
			walletName: walletName,
			// adminId: 2
			adminId: val.adminIDS
		};
		dispatch(adminAddOrUpdateCurrency(req, authToken));
	};

	const addOrUpdateCurrencyFunc = () => {
		if (addOrUpdateCurrencyStatus) {
			if (addOrUpdateCurrencyRes.data.status == "success") {
				setAddOrUpdateCurrencyArray(addOrUpdateCurrencyRes.data);
				setNotificationOpen(true);
				getCurrencyMasterListReq();
				currencyCodeReq();
			}
			if (addOrUpdateCurrencyRes.data.status == "failed") {
				setAddOrUpdateCurrencyArray(addOrUpdateCurrencyRes.data);
				setNotificationOpen(true);
				if (
					addOrUpdateCurrencyRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					addOrUpdateCurrencyRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (addOrUpdateCurrencyRes.data.status == "Failed") {
				setAddOrUpdateCurrencyArray(addOrUpdateCurrencyRes.data);
				setNotificationOpen(true);
				if (
					addOrUpdateCurrencyRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					addOrUpdateCurrencyRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		addOrUpdateCurrencyFunc();
	}, [addOrUpdateCurrencyRes.data.status]);

	const setData = (row, fs) => {
		console.log(row, "////////////////////////////");
		if (fs == "view") {
			setViewOpen(true);
		}
		if (fs == "edit") {
			setEditOpen(true);
		}
		setUser({
			currency: row.currencyName,
			currencyCode: row.code,
			currencyId: row.currencyId,
			walletName: row.walletName
		});
	};

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const handleClose = () => {
		setEditOpen(false);
		setViewOpen(false);
		setAddOpen(false);
		setUser({
			currency: "",
			currencyCode: "",
			currencyId: "",
			walletName: ""
		});
	};

	const addCurrency = () => {
		setAddOpen(true);
	};

	return (
		<>
			<Layout>
				<Card>
					{/* <DialogTitle>Currency</DialogTitle> */}
					<Grid
						container
						style={{
							padding: "10px",
							marginTop: "1rem",
							marginLeft: "1rem",
							gap: "10px",
							textAlign: "center"
						}}
					>
						<Grid item xs={12} md={4} sm={3} lg={5}></Grid>
						<Grid item xs={12} md={3} sm={3} lg={3}>
							{/* <Button
								variant="contained"
								style={{ backgroundColor: "#00b9f5", color: "white" }}
								size="small"
								onClick={() => addCurrency()}
							>
								Add New Currency
							</Button> */}
							<CustomButton
								style={{
									padding: "8px",
									marginLeft: "15px"
								}}
								onClick={() => addCurrency()}

							>
								Add New Currency
							</CustomButton>
						</Grid>
						<Grid item xs={12} md={3} sm={3} lg={3}>
							<NavLink to="/index/CurrencyMapping">
								{/* <Button
									variant="contained"
									style={{ backgroundColor: "#00b9f5", color: "white" }}
									size="small"
								>
									Mapping Currency
								</Button> */}
								<CustomButton
									style={{
										padding: "8px",
										marginLeft: "15px"
									}}


								>
									Mapping Currency
								</CustomButton>
							</NavLink>
						</Grid>
					</Grid>

					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						<Grid item xs={12} sm={12} md={4} lg={4}>
							<TextField
								select
								size="small"
								color="primary"
								type="text"
								label="Currency Code"
								variant="standard"
								fullWidth={true}
								name="searchCurrency"
								defaultValue={"Select Currency Code" || searchCurrency}
								onChange={handleChange}
							>
								<MenuItem
									value="Select Currency Code"
									selected="Select Currency Code"
								>
									Select Currency Code
								</MenuItem>
								{adminCurrencyCodeRes.data.currencyList &&
									[].concat(adminCurrencyCodeRes.data.currencyList).map((x) => (
										<MenuItem value={x.split("-")[0]}>
											{x.split("-")[1]}
										</MenuItem>
									))}
                            
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={4} lg={4}>
							{/* <Button
								style={{
									backgroundColor: "#00b9f5",
									color: "white",
									marginTop: "9px"
								}}
								endIcon={<AiOutlineSearch />}
								variant="contained"
								onClick={getCurrencyMasterListReq}
							>
								Search
							</Button> */}
							<CustomButton
								style={{
									padding: "8px",
									marginLeft: "15px"
								}}
								onClick={getCurrencyMasterListReq}
							>
								Search <SearchIcon />
							</CustomButton>
						</Grid>
					</Grid>
				</Card>

				{isLoading ? (
					<LoadingSpinner />
				) : getCurrencyMasterArray.length == undefined ||
					getCurrencyMasterArray.status == "NOT FOUND" ||
					!getCurrencyMasterStatus ? (
					<Card>
						{/* <Typography variant="body1">Report Table</Typography> */}
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography variant="body1" style={{ fontWeight: "700" }}
									className="themeText"

								>
									Report Table
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 tableHeaderColor"
									variant="secondary"
								// style={{ backgroundColor: "#00b9f5", color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography variant="body1" style={{ fontWeight: "700" }}
									className="themeText"

								>
									Report Table
								</Typography>
							</Grid>
							<TableContainer component={Paper} className="my-3">
								<Table
									className={classes.table}
									size="small"
									aria-label="a dense table"
								>
									<TableHead>
										<TableRow className="tableHeaderColor">
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Currency ID
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Currency
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Currency Code
											</TableCell>
											<TableCell
												colSpan={2}
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Action
											</TableCell>
										</TableRow>
									</TableHead>

									<TableBody>
										{getCurrencyMasterArray &&
											[]
												.concat(getCurrencyMasterArray)
												.slice(
													page * rowsPerPage,
													page * rowsPerPage + rowsPerPage
												)
												.map((row, index) => (
													<TableRow>
														<TableCell align="center">
															{row.currencyId}
														</TableCell>
														<TableCell align="center">
															{row.currencyName}
														</TableCell>
														<TableCell align="center">{row.code}</TableCell>
														<TableCell align="center">
															<CustomButton
																style={{
																	padding: "8px"
																}}
																onClick={() => setData(row, view)}
															>
																<VisibilityIcon style={{ color: "#fff" }} />
															</CustomButton>
														</TableCell>
														<TableCell align="center">
															<CustomButton
																style={{
																	padding: "8px"
																}}
																onClick={() => setData(row, edit)}
															>
																<EditIcon style={{ color: "#fff" }} />
															</CustomButton>
														</TableCell>
													</TableRow>
												))}
									</TableBody>
								</Table>
								<TablePagination
									rowsPerPageOptions={[5, 10, 25]}
									component="div"
									count={getCurrencyMasterArray.length}
									rowsPerPage={rowsPerPage}
									page={page}
									onPageChange={handleChangePage}
									onRowsPerPageChange={handleChangeRowsPerPage}
								/>
							</TableContainer>
						</Grid>
					</Card>
				)}
				<div>
					<Dialog open={editOpen} onClose={handleClose}>
						<DialogTitle>Edit Currency</DialogTitle>
						<DialogContent>
							<TextField
								required
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Currency"
								fullWidth={true}
								name="currency"
								value={currency || ""}
								variant="standard"
								onChange={(e) => onInputChange(e, "alphabet")}
							></TextField>
							<TextField
								required
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Currency Code"
								fullWidth={true}
								name="currencyCode"
								variant="standard"

								value={currencyCode || ""}
								onChange={(e) => onInputChange(e, "alphabetsNoSpace")}
							></TextField>

							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Default Name"
								fullWidth={true}
								name="walletName"
								variant="standard"

								defaultValue={walletName || ""}
								onChange={(e) => onInputChange(e, "both")}
							></TextField>
						</DialogContent>
						<DialogActions style={{ padding: "14px" }}>
							<Button
								style={{
									backgroundColor: "#fff",
									color: "#000"
								}}
								variant="contained"
								onClick={handleClose}
							>
								Cancel
							</Button>
							<Button
								style={{
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={addOrUpdateCurrencyReq}
							>
								Save
							</Button>
						</DialogActions>
					</Dialog>
				</div>
				<div>
					<Dialog open={viewOpen} onClose={handleClose}>
						<DialogTitle>View Currency</DialogTitle>
						<DialogContent>
							<TextField
								required
								disabled
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								variant="standard"
								label="Currency"
								fullWidth={true}
								name="currency"
								value={currency || ""}
							></TextField>
							<TextField
								required
								disabled
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								variant="standard"

								type="text"
								label="Currency Code"
								fullWidth={true}
								name="currencyCode"
								value={currencyCode || ""}
							></TextField>

							<TextField
								disabled
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								variant="standard"

								label="Default Name"
								fullWidth={true}
								name="walletName"
								defaultValue={walletName || ""}
							></TextField>
						</DialogContent>
						<DialogActions style={{ padding: "14px" }}>
							<Button
								style={{
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleClose}
							>
								Close
							</Button>
						</DialogActions>
					</Dialog>
				</div>
				<div>
					<Dialog open={addOpen} onClose={handleClose}>
						<DialogTitle style={{ minWidth: "600px" }}>
							Add Currency
						</DialogTitle>
						<DialogContent>
							<TextField
								required
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Currency"
								fullWidth={true}
								name="currency"
								value={currency || ""}
								variant="standard"
								onChange={(e) => onInputChange(e, "alphabet")}
							></TextField>
							<TextField
								required
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Currency Code"
								fullWidth={true}
								name="currencyCode"
								value={currencyCode || ""}
								variant="standard"

								onChange={(e) => onInputChange(e, "currencyCode")}
							></TextField>

							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Default Name"
								fullWidth={true}
								name="walletName"
								defaultValue={walletName || ""}
								variant="standard"

								onChange={(e) => onInputChange(e, "both")}
							></TextField>
						</DialogContent>
						<DialogActions style={{ padding: "14px" }}>
							<Button
								style={{
									backgroundColor: "#fff",
									color: "#000"
								}}
								variant="contained"
								onClick={handleClose}
							>
								Cancel
							</Button>
							<Button
								style={{
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={addOrUpdateCurrencyReq}
							>
								Save
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			</Layout>

			{addOrUpdateCurrencyArray.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{addOrUpdateCurrencyArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{addOrUpdateCurrencyArray.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{addOrUpdateCurrencyArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
}

export default AdminCurrencyMaster;
